import React from 'react'

const Important = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4.63636C7.93318 4.63636 4.63636 7.93318 4.63636 12C4.63636 16.0668 7.93318 19.3636 12 19.3636C16.0668 19.3636 19.3636 16.0668 19.3636 12C19.3636 7.93318 16.0668 4.63636 12 4.63636ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 11.1818C12.4519 11.1818 12.8182 11.5481 12.8182 12V15.2727C12.8182 15.7246 12.4519 16.0909 12 16.0909C11.5481 16.0909 11.1818 15.7246 11.1818 15.2727V12C11.1818 11.5481 11.5481 11.1818 12 11.1818ZM11.9959 7.90909C11.5463 7.90909 11.1818 8.2754 11.1818 8.72727C11.1818 9.17914 11.5463 9.54545 11.9959 9.54545H12.0041C12.4537 9.54545 12.8182 9.17914 12.8182 8.72727C12.8182 8.2754 12.4537 7.90909 12.0041 7.90909H11.9959Z"
        fill="#527EDB"
      />
    </svg>
  );
}

export default Important